import type { VoidFunctionComponent } from 'react';

import List from '../../generic/List';

import styles from './ActivityFeed.module.less';

// Placeholder row shape until the activity API is wired up; replace it with that API's entry type.
export type ActivityFeedEntry = {
  id: string;
  title: string;
};

type Props = {
  isLoading: boolean;
  isError: boolean;
  entries: ActivityFeedEntry[] | null;
  //  A filter that matched nothing is not an organization with no activity.
  isFiltered: boolean;
};

export const ACTIVITY_ERROR_COPY = 'Activity couldn\'t be loaded. Try again in a moment.';
export const ACTIVITY_EMPTY_COPY = 'No Legal Agent activity yet.';
export const ACTIVITY_FILTERED_EMPTY_COPY = 'No activity matches this selection.';

const LOADING_ROW_KEYS = ['1', '2', '3', '4', '5', '6'];

export const ActivityFeed: VoidFunctionComponent<Props> = ({ isLoading, isError, entries, isFiltered }) => {
  const rows = entries ?? [];

  return (
    //  Skeleton rows are wordless SVGs, so aria-busy tells a screen reader the feed is loading.
    <div aria-busy={isLoading} data-test-id="legal-agent-activity-feed">
      <List>
        <List.Body>
          {isLoading && LOADING_ROW_KEYS.map((key) => <List.RowLoading key={key} isInteractive={false} />)}
          {!isLoading && (isError || rows.length === 0) && (
            <div className={styles.empty} role={isError ? 'alert' : 'status'}>
              {isError ? ACTIVITY_ERROR_COPY : (isFiltered ? ACTIVITY_FILTERED_EMPTY_COPY : ACTIVITY_EMPTY_COPY)}
            </div>
          )}
          {!isLoading && rows.map((entry) => (
            <List.RowContainer key={entry.id}>
              <List.Row isInteractive={false} testId="legal-agent-activity-row">
                {entry.title}
              </List.Row>
            </List.RowContainer>
          ))}
        </List.Body>
      </List>
    </div>
  );
};
